import React from "react";
import photoImg from "../../../src/asset/images/img-icon.svg";
import eyeIcon from "../../../src/asset/images/eyeIcon.svg";
import deleteImg from "../../asset/images/delete-red.svg";
import righttick from "../../../src/asset/images/check-circle-green.svg";
import checkCircle from "../../asset/images/check_circle.svg";
import docImage from "../../asset/images/photo-img.svg"

const DocumentUploader = ({
  label,
  docKey,
  fileState,
  setFile,
  error,
  setError,
  onDelete,
  onPreview,
  documentData,
  handleUpload,
  onChange,
  optional,
}) => {
  const isAvailable = documentData[docKey]?.isAvailable;
  const fileName = documentData[docKey]?.name || fileState?.name;

  console.log(documentData[docKey]?.name,documentData, "documentData");
  

  return (
    <div className="list-col">
      <div className="form-group pan-input custom-suggest partner-form">
        <div className="pan-data">
          <div className="label-wrapper">
            <label className="doc-name">
              {label}
              {!optional && <span className="mandatory-label">*</span>}
            </label>
            {isAvailable && (
              <label className="green-text">
                Uploaded 
                <img src={checkCircle} alt="check_circle" />
              </label>
            )}
          </div>
          {!isAvailable && <label className="default-text">Upload self-attested document</label>}
          {isAvailable ? (
            <div className="doc-uploaded">
              <div className="doc-text">
                <div className="check-image">
                  <span className="file-wrap">
                    <img src={docImage} alt="document-pic" />
                    <label className="img-name" title={fileName}>{fileName}</label>
                  </span>
                  <div className="wrap-del-preview">
                    <button type="button" onClick={() => onDelete(docKey)} className="del-btn">
                      <img src={deleteImg} alt="delete icon" /> Delete
                    </button>
                    <div className="preview-text">
                      <span 
                      className="icon-text" 
                      type="button" 
                      // onClick={onPreview(documentData[docKey]?.url, documentData[docKey]?.name || fileState?.name)}
                      onClick={() =>
                        onPreview(
                          documentData[docKey]?.name,
                          documentData[docKey]?.url,
                          label
                          // documentData[docKey]?.name || fileState?.name
                        )
                      }
                      >
                        <img src={eyeIcon} alt="eye icon" /> Preview
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : error ? (
            <div className="image" id="uploadimg">
              <span className="forget-link wrong-format doc-error">{error}</span>
            </div>
          ) : null}
        </div>

        <div className="buttons-partner">
          <input
            type="file"
            id={label.replace(/\s/g, "")}
            accept="image/png, image/jpeg, image/jpg, application/pdf"
            className="pan-form"
            onChange={(e) => onChange(e)}
            // onChange={(e) =>
            //   handleUpload({
            //     e,
            //     type: parseInt(docKey),
            //     setFile,
            //     setError,
            //   })
            // }
            key={fileState?.name || ""}
          />
          {isAvailable ? (
            <label className="disable-btn">Choose File</label>
          ) : (
            <label htmlFor={label.replace(/\s/g, "")}>Choose File</label>
          )}
        </div>
      </div>
    </div>
  );
};

export default DocumentUploader;